import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmService } from 'src/app/services/confirm.service';
import { RumiService } from 'src/app/services/rumi.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html'
})
export class HeaderComponent {

	public logo = '/rumi/assets/img/logo.png';

	constructor(
		private readonly translate: TranslateService,
		private rumiService: RumiService,
		private router: Router,
		private confirm: ConfirmService
	) { }

	/**
	 * Change current language on the translation service.
	 * @param locale new locale to use on translations.
	 */
	public changeLanguage(locale: string) {
		this.translate.use(locale);
	}

	/**
	 * @returns current language used.
	 */
	public get language(): string {
		return this.translate.currentLang;
	}	

	public get simulacio (){
		return this.rumiService.simulacio;
	}
	public get pestanyaActiva(): string {
		return this.rumiService.pestanyaActiva;
	}	

	tancarSimulacio(){
		this.rumiService.simulacio = null;
		this.rumiService.pestanyaActiva = 'simulacio';
		this.router.navigate(['home']);
	}

}
